import { useState, useEffect } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Tag } from "lucide-react";
import SEOHead from "@/components/SEOHead";
import BundleCard from "@/components/BundleCard";

export default function Bundles() {
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api.get("/bundles")
      .then((r) => { if (active) setBundles(r.data); })
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)))
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return (
    <div data-testid="bundles-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
      <SEOHead
        title="Deals & Bundles — Save More on Kit"
        description="Untamed Gear bundles & special offers. Build your kit and save more on rugby, hockey and netball gear. Limited-time deals while stocks last."
        canonicalPath="/deals"
        keywords="untamed gear bundles, rugby kit deals, sportswear bundle south africa, save on kit"
      />

      <div className="mb-10 sm:mb-14">
        <p className="text-[#F7931E] text-xs sm:text-sm font-bold uppercase tracking-[0.3em] mb-3">Build Your Kit. Save More.</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter uppercase text-white font-heading">
          Gear Up &amp; Save
        </h1>
        <p className="text-[#A3A3A3] mt-4 max-w-2xl text-sm sm:text-base">
          Hand-picked bundles that pair your favourite Untamed gear together at a sharper price. Same quality, bigger saving.
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-24"><Loader2 size={32} className="animate-spin text-[#F7931E]" /></div>
      ) : bundles.length === 0 ? (
        <div data-testid="bundles-empty" className="text-center py-24 border border-[#262626] bg-[#171717]">
          <Tag size={40} className="mx-auto text-[#525252] mb-4" />
          <p className="text-white font-bold uppercase tracking-wide font-heading">No live deals right now</p>
          <p className="text-[#A3A3A3] text-sm mt-2">New bundles drop regularly — check back soon.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {bundles.map((b) => <BundleCard key={b.id} bundle={b} />)}
        </div>
      )}
    </div>
  );
}
